<template>
  <div class="card">
    <div class="head">{{ card.name }}</div>
    <p class="description">{{ card.keyword }}</p>
    <div class="image" v-lazy:background-image="card.thumbnail">
      <i class="iconfont icon-D" v-if="card.model"></i>
    </div>
    <p class="foot">去看看 ►</p>
  </div>
</template>

<script>
  import {Lazyload} from 'vant';
  import Vue from 'vue';
  Vue.use(Lazyload, {

  });

  export default {
    name: "card-gallery",
    props: {
      card: {
        type: Object,
        default() {
          return {
            name: '展览标题',
            description: '展览描述',
            thumbnail: ''
          }
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .card {
    padding: 0.21rem;
    padding-bottom: 0;
    background-color: #fff;
    overflow: hidden;

    .head {
      text-align: center;
      font-size: 20px;
      line-height: 32px;
      font-weight: bold;
      color: #2a2a2a;
      margin-top: 0.5rem;
      margin-bottom: 0.2rem;
    }

    .description {
      text-align: center;
      font-size: 14px;
      line-height: 18px;
      /*color: @color-text-light;*/
      color: #656565;
      margin-bottom: 0.1rem;
    }

    .image {
      width: 7.06rem;
      height: 7.5rem;
      max-width: 750px;
      margin: 0 auto;
      background-color: #fafafa;
      background-size: cover;
      background-position: center top;
      .iconfont{
        display: inline-block;
        margin-top: 14px;
        margin-left: 6px;
        font-size: 30px;
        color:  #d7b563;
      }
    }

    .foot {
      text-align: center;
      font-size: 12px;
      line-height: 56px;
      color: #1d1d1d;
    }
  }

</style>